import ownerDocument from './owner-document';

var getWindow = function getWindow(element) {
  return ownerDocument(element).defaultView;
};

export default getWindow;